"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkTypeError = exports.InvalidMenuDepthError = exports.InvalidTargetError = exports.InvalidLabelError = void 0;
const errors_1 = require("../../errors");
const messages_1 = require("../../messages");
class InvalidLabelError extends errors_1.NilAssignmentError {
    constructor(index) {
        super({
            functionName: 'menuItems',
            propertyName: 'label',
            index,
        });
        this.name = 'InvalidLabelError';
    }
}
exports.InvalidLabelError = InvalidLabelError;
class InvalidTargetError extends Error {
    constructor({ index, label, target, }) {
        super(messages_1.messageTemplates.error_menu_items_target({
            index,
            label,
            target,
        }));
        this.name = 'InvalidTargetError';
    }
}
exports.InvalidTargetError = InvalidTargetError;
class InvalidMenuDepthError extends Error {
    constructor(maxLevels, labelValue) {
        super(messages_1.messageTemplates.error_menu_items_depth({
            labelValue,
            maxLevels,
        }));
        this.name = 'InvalidMenuDepth';
    }
}
exports.InvalidMenuDepthError = InvalidMenuDepthError;
class LinkTypeError extends errors_1.UnsupportedLinkTypeError {
    constructor(wrongValue, index) {
        super({
            functionName: 'menuItems',
            propertyName: 'link',
            wrongValue,
            index,
        });
    }
}
exports.LinkTypeError = LinkTypeError;
//# sourceMappingURL=errors.js.map